// @ts-nocheck
import React from 'react';
import { Drawer, DrawerSuspense } from '@/components';
import withDrawers from '@/containers/Drawer/withDrawers';

import { compose } from '@/utils';

const SalesOrderDetailDrawerContent = React.lazy(() =>
  import('./SalesOrderDetailDrawerContent'),
);

/**
 * Sales Order Detail drawer.
 */
function SalesOrderDetailDrawer({
  name,
  // #withDrawer
  isOpen,
  payload: { salesOrderId },
}) {
  return (
    <Drawer
      isOpen={isOpen}
      name={name}
      style={{ minWidth: '700px', maxWidth: '1000px' }}
      size={'65%'}
    >
      <DrawerSuspense>
        <SalesOrderDetailDrawerContent salesOrderId={salesOrderId} />
      </DrawerSuspense>
    </Drawer>
  );
}
export default compose(withDrawers())(SalesOrderDetailDrawer);
